import React from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import Formwizard from '../../components/Formwizard';
import SEO from '../../components/SEO';
import Link from '../../components/Link';
import FooterStraightLine from '../../components/FooterStraightLine';
import PressLogos from '../../components/PressLogos';
import { EVENT_OBJECT, EVENT_VERB, eventBuilder } from '../../utils/tracking';

const Two = ({ data, location }) => {
  const page = get(data, 'contentfulPage');

  return (
    <div>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/legacy/newlegacylayout.css"
        />
      </Helmet>
      <SEO
        entity={page}
        title={page.metaTitle || page.title}
        canonical={page.canonical}
        type="page"
        description={page.metaDescription}
        indexable={page.indexable}
      />
      <header className="newlegacy">
        <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top px-0 shadow">
          <div className="container-fluid justify-content-between">
            <span className="d-block d-md-block mr-md-0 py-0 pr-0 pl-2 px-md-6 navbar-brand">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={150}
                height={21}
                className="logo"
                viewBox="0 0 134 18"
              >
                <path
                  fill="#1694f4"
                  d="M133.45 5.5a9.8 9.8 0 01.06 6.38 7.95 7.95 0 01-4.29 4.81 8.8 8.8 0 01-3.76.75h-6.6V.01h6.6c1.4 0 2.64.25 3.71.75a7.92 7.92 0 014.28 4.75zm-4.27 4.9a5.94 5.94 0 00-.01-3.37 3.9 3.9 0 00-2.03-2.49 3.74 3.74 0 00-1.75-.39h-2v9.16h2a3.77 3.77 0 003.04-1.44c.35-.44.6-.94.76-1.47h-.01zM110.4.01h-4.53v17.43h10.81V13.3h-6.28zM103.86 5.04c.5 1.13.75 2.44.75 3.94a9.8 9.8 0 01-.65 3.64 8.3 8.3 0 01-1.83 2.83c-.8.8-1.76 1.43-2.81 1.84a10.2 10.2 0 01-6.9.11 7.92 7.92 0 01-4.79-4.47 9.8 9.8 0 01-.74-3.95c0-1.5.26-2.82.77-3.94A8.19 8.19 0 0192.52.57a9.9 9.9 0 016.52 0 8.22 8.22 0 014.82 4.47zm-4.14 5.98c.27-.65.4-1.34.38-2.04.01-.7-.11-1.39-.37-2.04a4.37 4.37 0 00-.98-1.45c-.39-.38-.85-.68-1.37-.87a4.48 4.48 0 00-1.56-.28c-.56 0-1.11.09-1.64.27-.52.18-1 .47-1.4.86-.43.4-.77.9-1 1.45-.25.65-.38 1.36-.37 2.06-.01.7.11 1.39.37 2.04a4.07 4.07 0 002.36 2.33 4.48 4.48 0 003.21 0 4.08 4.08 0 002.37-2.33zM76.82 7.8v3.9h3.76a3.7 3.7 0 01-1.55 1.73c-.6.32-1.36.47-2.27.47-.63.01-1.25-.11-1.83-.36-.53-.22-1-.57-1.38-1a4.64 4.64 0 01-.88-1.54 6.07 6.07 0 01-.32-2.02c0-.65.1-1.3.3-1.93.17-.57.46-1.11.84-1.58a4.04 4.04 0 013.27-1.5c.85 0 1.57.14 2.15.44.58.3 1.07.8 1.47 1.52h4.35s-.58-1.83-1.15-2.65A7.26 7.26 0 0079.36.36a9.65 9.65 0 00-5.8.22 8.24 8.24 0 00-4.88 4.5 9.41 9.41 0 00-.76 3.93c0 1.49.25 2.8.76 3.91a8.26 8.26 0 004.88 4.47 9.73 9.73 0 005.62.28 8.13 8.13 0 002.21-.9 7.12 7.12 0 003.14-3.91c.27-.82.44-1.66.5-2.52.04-.85.03-1.7-.04-2.53h-8.17zm-12.86.45c-.66-.4-1.4-.7-2.15-.84-.86-.18-1.72-.3-2.58-.38a7.18 7.18 0 01-1.92-.4c-.45-.18-.68-.56-.68-1.14-.01-.28.06-.56.22-.8.14-.2.33-.35.55-.45.24-.11.5-.19.75-.22.26-.04.51-.06.77-.06.56-.02 1.1.12 1.6.39.46.26.7.68.71 1.27h4.21A4.93 4.93 0 0063.4 1.4 6.5 6.5 0 0061.28.35a9.1 9.1 0 00-4.96 0c-.77.22-1.49.57-2.13 1.04a5.15 5.15 0 00-2.02 4.21c0 .9.18 1.67.54 2.28.35.61.83 1.13 1.42 1.51.62.4 1.3.7 2.01.86.76.2 1.53.31 2.31.36.31.02.65.04 1.02.08.35.03.7.1 1.03.23.3.11.57.3.8.53.2.23.31.55.31.96 0 .25-.07.5-.23.7-.17.2-.37.37-.6.5a4.18 4.18 0 01-3.68-.01 1.9 1.9 0 01-.61-.56c-.16-.23-.24-.5-.23-.78h-4.32a4.98 4.98 0 002.15 4.3c.7.48 1.46.83 2.28 1.03a10.53 10.53 0 005.26 0 7.3 7.3 0 002.28-1.02 5.32 5.32 0 001.6-1.72c.42-.73.63-1.57.61-2.4 0-1.07-.18-1.93-.55-2.6a4.37 4.37 0 00-1.51-1.6h-.1zM45.4 11.56a1.84 1.84 0 01-.8 1.57c-.23.17-.5.3-.8.37a3.39 3.39 0 01-1.84 0c-.29-.07-.56-.2-.8-.37a1.84 1.84 0 01-.8-1.56V0h-4.4v11.65a5.43 5.43 0 002.14 4.45c.68.5 1.43.89 2.24 1.13 1.7.51 3.53.51 5.23 0 .8-.24 1.56-.62 2.23-1.13a5.4 5.4 0 002.12-4.44V0H45.4v11.55zM28.7 13.62a27.45 27.45 0 01-4.73 3.23h10.78s-.92-3.2-2.3-6.85c-1.2 1.31-1.88 2.14-3.75 3.62z"
                />
                <path
                  d="M15.98 17.4S20.53.01 25 .01c1.73 0 3.63 3.09 5.24 6.67-3.2 3.93-9 8.42-12.7 10.72h-1.56z"
                  fill="#f46364"
                />
                <path
                  fill="#1694f4"
                  d="M9.93 6.28h-5.4V.01H0v17.3h4.53v-6.89h5.4v7.02h4.53V.01H9.93z"
                />
              </svg>
            </span>
            <span className="d-none d-md-none mr-md-6 py-0 px-3 px-md-6 navbar-brand">
              <svg
                className="signet"
                width="30px"
                height="29px"
                viewBox="0 0 19 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <g id="rakete">
                  <path
                    d="M13.7010318,13.6220694 C11.5635297,15.3164573 10.9864041,15.7152843 8.9708653,16.8452942 L19.7501627,16.8452942 C19.7501627,16.8452942 18.8272648,13.6584405 17.4479472,9.99876345 C16.2484313,11.3106285 15.5669454,12.1446536 13.7010318,13.6220694 L13.7010318,13.6220694 Z"
                    fill="#f46364"
                  />
                  <path
                    d="M0.9805769,17.403775 C0.9805769,17.403775 5.5309417,0.0109028931 9.9995784,0.0109028931 C11.7322125,0.0109028931 13.6295599,3.09993116 15.2427454,6.67557858 C12.0478084,10.613682 6.2375747,15.1011133 2.5371814,17.403775 L0.9805769,17.403775 L0.9805769,17.403775 Z"
                    fill="#F46364"
                  />
                </g>
              </svg>
            </span>
            <div id="navbarNav">
              <div className="d-lg-flex justify-content-between w-100 pr-2 pl-0 px-md-6">
                <Link
                  className="text-dark pr-md-0 font-weight-semibold"
                  to="tel:+494022616140"
                  eventName={eventBuilder(
                    EVENT_OBJECT.headerLink,
                    EVENT_VERB.interacted
                  )}
                  eventLabel="Experten Hotline 040 - 22 61 61 40"
                >
                  <span className="mr-2">Experten Hotline</span>
                  <svg
                    style={{ width: '24px', height: '24px' }}
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#3f3e4b"
                      d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"
                    />
                  </svg>
                  <span className="d-none d-md-inline-block pl-md-2">
                    040 - 22 61 61 40
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </nav>
        <div className="container p-0">
          <div className="row justify-content-center d-flex">
            <div className="formwizard col-11 col-lg-8 mt-0 mt-sm-6 mt-md-6 p-0">
              <h1 className="display-4 text-center d-md-block mb-2 mt-4">
                Immobilienbewertung von Experten anfordern! 100% kostenlos
              </h1>
              <div
                className="card shadow border-primary border-2"
                style={{ zIndex: 1 }}
              >
                <div className="card-body m-0 p-0">
                  <Formwizard
                    position="header"
                    location={location}
                    url="https://formwizard.hausgold.de/formular/standard-01/start"
                  />
                </div>
                <div className="card-footer" style={{ background: '#fafbff' }}>
                  <ul className="d-none d-md-flex list-inline icon-list m-0 justify-content-between">
                    <li className="list-inline-item" style={{ width: '25%' }}>
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 24 24"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <path
                          d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41,-1.41z"
                          style={{ fill: '#19dc9b' }}
                        />
                      </svg>
                      <small className="text-muted">
                        Schnell Angaben zur Immobilie machen
                      </small>
                    </li>
                    <li className="list-inline-item" style={{ width: '30%' }}>
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 24 24"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <path
                          d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41,-1.41z"
                          style={{ fill: '#19dc9b' }}
                        />
                      </svg>
                      <small className="text-muted">
                        Einfach und unverbindlich Formular ausfüllen
                      </small>
                    </li>
                    <li className="list-inline-item" style={{ width: '22%' }}>
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 24 24"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <path
                          d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41,-1.41z"
                          style={{ fill: '#19dc9b' }}
                        />
                      </svg>
                      <small className="text-muted">
                        Kostenlose Experten-
                        <br />
                        bewertung vor Ort
                      </small>
                    </li>
                  </ul>
                  <ul className="d-block d-md-none icon-list m-0 p-0">
                    <li className="list-inline-item">
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 24 24"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <path
                          d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41,-1.41z"
                          style={{ fill: '#19dc9b' }}
                        />
                      </svg>
                      <small className="text-muted">
                        Schnell Angaben zur Immobilie machen
                      </small>
                    </li>
                    <li className="list-inline-item">
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 24 24"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <path
                          d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41,-1.41z"
                          style={{ fill: '#19dc9b' }}
                        />
                      </svg>
                      <small className="text-muted">
                        Einfach und unverbindlich Formular ausfüllen
                      </small>
                    </li>
                    <li className="list-inline-item">
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 24 24"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <path
                          d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41,-1.41z"
                          style={{ fill: '#19dc9b' }}
                        />
                      </svg>
                      <small className="text-muted">
                        Kostenlose Expertenbewertung vor Ort
                      </small>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="container">
        <div className="contain pt-6 pt-lg-5">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-12 col-lg-10 mt-5">
                <PressLogos />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="process" className="mt-4 mt-md-7 d-none d-lg-block mb-md-5">
        <div className="container">
          <div className="row justify-content-center">
            <h1 className="text-center col-12 col-md-8 display-2 mb-6">
              In nur 5 Schritten bringt Sie{' '}
              <span className="text-uppercase">Hausgold</span> ans Ziel:
            </h1>
          </div>
          <div className="card-deck mt-6">
            <div className="card shadow mb-md-3 mb-lg-0">
              <div className="card-body text-center">
                <div
                  className="rounded-circle bg-success text-white d-flex justify-content-center align-items-center mx-auto mb-4"
                  style={{ width: '36px', height: '36px' }}
                >
                  1
                </div>
                <h2 className="mb-2">Ausfüllen</h2>
                <p>Schnell und einfach Online-Formular ausfüllen.</p>
              </div>
            </div>
            <div className="w-100 d-md-block d-lg-none">
              {/* Wrap every 2 on sm */}
            </div>
            <div className="card shadow mb-md-3 mb-lg-0">
              <div className="card-body text-center">
                <div
                  className="rounded-circle bg-success text-white d-flex justify-content-center align-items-center mx-auto mb-4"
                  style={{ width: '36px', height: '36px' }}
                >
                  2
                </div>
                <h2 className="mb-2">Aussuchen</h2>
                <p>
                  Wir melden uns und stellen Ihnen passende Immobilienexperten
                  vor.
                </p>
              </div>
            </div>
            <div className="w-100 d-md-block d-lg-none">
              {/* Wrap every 2 on sm */}
            </div>
            <div className="card shadow mb-md-3 mb-lg-0">
              <div className="card-body text-center">
                <div
                  className="rounded-circle bg-success text-white d-flex justify-content-center align-items-center mx-auto mb-4"
                  style={{ width: '36px', height: '36px' }}
                >
                  3
                </div>
                <h2 className="mb-2">Bewerten</h2>
                <p>
                  Unser Fachmann ermittelt kostenlos den Marktwert Ihrer
                  Immobilie vor Ort.
                </p>
              </div>
            </div>
            <div className="w-100 d-md-block d-lg-none">
              {/* Wrap every 2 on sm */}
            </div>
            <div className="card shadow mb-md-3 mb-lg-0">
              <div className="card-body text-center">
                <div
                  className="rounded-circle bg-success text-white d-flex justify-content-center align-items-center mx-auto mb-4"
                  style={{ width: '36px', height: '36px' }}
                >
                  4
                </div>
                <h2 className="mb-2">Entscheiden</h2>
                <p>
                  Sie entscheiden, ob Sie mit unserem Makler vermarkten möchten.
                </p>
              </div>
            </div>
            <div className="w-100 d-md-block d-lg-none">
              {/* Wrap every 2 on sm */}
            </div>
            <div className="card shadow mb-md-3 mb-lg-0">
              <div className="card-body text-center">
                <div
                  className="rounded-circle bg-success text-white d-flex justify-content-center align-items-center mx-auto mb-4"
                  style={{ width: '36px', height: '36px' }}
                >
                  5
                </div>
                <h2 className="mb-2">Verkaufen</h2>
                <p>Verkaufen Sie Ihre Immobilie erfolgreich zum Top-Preis.</p>
              </div>
            </div>
            <div className="w-100 d-md-block d-lg-none">
              {/* Wrap every 2 on sm */}
            </div>
          </div>
          <div className="steps animation-element in-view d-none d-lg-flex mt-2 mb-6 justify-content-center">
            <svg width={244} height={68} xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fillRule="evenodd">
                <path
                  className="path path-1"
                  d="M7.3 7.3c19.7 34.7 65 59 117.5 59S222.4 42 242.3 7.4"
                  stroke="#3f3e4b"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <path
                  className="dashed"
                  d="M7.3 7.3c1.3 2.3 2.7 4.5 4.2 6.7 21.6 31.1 64.2 52.3 113.3 52.3 52.5 0 97.6-24.2 117.5-58.9"
                  stroke="#fff"
                  strokeWidth={3}
                  strokeLinecap="round"
                />
                <circle
                  className="circle circle-1"
                  fill="#3f3e4b"
                  cx={7}
                  cy={7}
                  r={7}
                />
              </g>
            </svg>
            <svg
              style={{ marginLeft: '-10px' }}
              width={244}
              height={68}
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  className="path path-2"
                  d="M7.3 7.3c19.7 34.7 65 59 117.5 59S222.4 42 242.3 7.4"
                  stroke="#3f3e4b"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <path
                  className="dashed"
                  d="M7.3 7.3c1.3 2.3 2.7 4.5 4.2 6.7 21.6 31.1 64.2 52.3 113.3 52.3 52.5 0 97.6-24.2 117.5-58.9"
                  stroke="#fff"
                  strokeWidth={3}
                  strokeLinecap="round"
                />
                <circle
                  className="circle circle-2"
                  fill="#3f3e4b"
                  cx={7}
                  cy={7}
                  r={7}
                />
              </g>
            </svg>
            <svg
              style={{ marginLeft: '-10px' }}
              width={244}
              height={68}
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  className="path path-3"
                  d="M7.3 7.3c19.7 34.7 65 59 117.5 59S222.4 42 242.3 7.4"
                  stroke="#3f3e4b"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <path
                  className="dashed"
                  d="M7.3 7.3c1.3 2.3 2.7 4.5 4.2 6.7 21.6 31.1 64.2 52.3 113.3 52.3 52.5 0 97.6-24.2 117.5-58.9"
                  stroke="#fff"
                  strokeWidth={3}
                  strokeLinecap="round"
                />
                <circle
                  className="circle circle-3"
                  fill="#3f3e4b"
                  cx={7}
                  cy={7}
                  r={7}
                />
              </g>
            </svg>
            <svg
              style={{ marginLeft: '-10px' }}
              width={244}
              height={68}
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  className="path path-4"
                  d="M7.3 7.3c19.7 34.7 65 59 117.5 59S222.4 42 242.3 7.4"
                  stroke="#3f3e4b"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <path
                  className="dashed"
                  d="M7.3 7.3c1.3 2.3 2.7 4.5 4.2 6.7 21.6 31.1 64.2 52.3 113.3 52.3 52.5 0 97.6-24.2 117.5-58.9"
                  stroke="#fff"
                  strokeWidth={3}
                  strokeLinecap="round"
                />
                <circle
                  className="circle circle-4"
                  fill="#3f3e4b"
                  cx={7}
                  cy={7}
                  r={7}
                />
                <path
                  className="arrow"
                  fill="#3f3e4b"
                  fillRule="nonzero"
                  d="M247.6 0l-2 15.5L234 7.7z"
                />
              </g>
            </svg>
          </div>
          <p className="text-center col-12 col-md-8 col-lg-5 offset-lg-1 mt-6 mt-lg-0 text-grey">
            <span className="text-uppercase">Hausgold</span> begleitet Sie durch
            den gesamten Prozess und steht jederzeit für Fragen bereit, um Ihnen
            einen einfachen Verkauf Ihrer Immobilie zu garantieren.
          </p>
        </div>
      </section>

      <FooterStraightLine />
    </div>
  );
};

export default Two;

export const pageQuery = graphql`
  query twoQuery {
    site {
      siteMetadata {
        title
      }
    }
    contentfulPage(slug: { eq: "2" }, template: { eq: "Landingpage" }) {
      id
      title
      headline
      metaTitle
      metaDescription
      subTitle
      canonical
      indexable
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
